import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from "react";
// Define the initial state
var initialState = {
    loadingCount: 0,
};
// Reducer function
function reducer(state, action) {
    switch (action.type) {
        case "SHOW_LOADER":
            return __assign(__assign({}, state), { loadingCount: state.loadingCount + 1 });
        case "HIDE_LOADER":
            return __assign(__assign({}, state), { loadingCount: state.loadingCount - 1 });
        default:
            return state;
    }
}
// Create contexts
var LoadingStateContext = createContext(undefined);
var LoadingDispatchContext = createContext(undefined);
// LoadingProvider component
function LoadingProvider(_a) {
    var children = _a.children;
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    // Dispatch actions
    var showLoading = function () { return dispatch({ type: "SHOW_LOADER" }); };
    var hideLoading = function () { return dispatch({ type: "HIDE_LOADER" }); };
    var actions = { showLoading: showLoading, hideLoading: hideLoading };
    return (_jsx(LoadingStateContext.Provider, { value: state, children: _jsx(LoadingDispatchContext.Provider, { value: actions, children: children }) }));
}
// Custom hook for state
function useLoadingState() {
    var context = useContext(LoadingStateContext);
    if (context === undefined) {
        throw new Error("useLoadingState must be used within a LoadingProvider");
    }
    return context;
}
// Custom hook for actions
function useLoadingActions() {
    var context = useContext(LoadingDispatchContext);
    if (context === undefined) {
        throw new Error("useLoadingActions must be used within a LoadingProvider");
    }
    return context;
}
export { LoadingProvider, useLoadingState, useLoadingActions };
